import { LoadingButton } from '@mui/lab';
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from '@mui/material';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import validErrors from '../../../../hooks/validErrors';
import { addPrize } from '../../../../data/api/prizes/PrizeRoutes';
import { Loading, Notify } from 'notiflix';
import moneyFormat from '../../../../hooks/moneyFormat';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const AddPrize = ({ token, loadData, handleClose }) => {
    const { register, handleSubmit, watch } = useForm({
        defaultValues: {
            hits: '',
            prize: '',
            compensation: 0,
        },
    });

    const [submit, setSubmit] = useState(false);

    const prizeValue = watch('prize');
    const compensation = Number(watch('compensation'));

    const onSubmit = async (dataForm) => {
        setSubmit(true);
        Loading.arrows();

        try {
            const { data } = await addPrize(token, dataForm);

            if (data?.success) {
                Notify.success(data?.message);
                loadData();
                handleClose();
            }
        } catch (error) {
            validErrors(error);
        } finally {
            setSubmit(false);
            Loading.remove();
        }
    };

    return (
        <ModalCard className="animate__animated animate__fadeInRight">
            <Header>
                <Box className="left">
                    <Box className="icon">
                        <EmojiEventsOutlinedIcon />
                    </Box>

                    <Box>
                        <Typography className="title">
                            Agregar premio
                        </Typography>

                        <Typography className="subtitle">
                            Define la recompensa según la cantidad de aciertos.
                        </Typography>
                    </Box>
                </Box>

                <IconButton
                    onClick={handleClose}
                    size="small"
                    className="close-btn"
                >
                    <CloseIcon />
                </IconButton>
            </Header>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SectionBox>
                            <SectionTitle>
                                <SportsEsportsOutlinedIcon />
                                <Box>
                                    <Typography className="section-title">
                                        Aciertos requeridos
                                    </Typography>
                                    <Typography className="section-subtitle">
                                        Cantidad de coincidencias necesarias para ganar.
                                    </Typography>
                                </Box>
                            </SectionTitle>

                            <TextField
                                variant="outlined"
                                label="Aciertos"
                                placeholder="Ej: 4"
                                fullWidth
                                type="number"
                                size="small"
                                sx={fieldStyles}
                                {...register('hits')}
                            />
                        </SectionBox>
                    </Grid>

                    <Grid item xs={12}>
                        <SectionBox>
                            <SectionTitle>
                                <PaidOutlinedIcon />
                                <Box>
                                    <Typography className="section-title">
                                        Premio y compensación
                                    </Typography>
                                    <Typography className="section-subtitle">
                                        Indica el valor del premio y el tipo de compensación.
                                    </Typography>
                                </Box>
                            </SectionTitle>

                            <Grid container spacing={1.5}>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        variant="outlined"
                                        label={
                                            prizeValue
                                                ? compensation === 1
                                                    ? moneyFormat(parseInt(prizeValue || 0))
                                                    : `${prizeValue} jugadas`
                                                : 'Premio'
                                        }
                                        placeholder="Ej: 50000"
                                        fullWidth
                                        type="number"
                                        size="small"
                                        sx={fieldStyles}
                                        {...register('prize')}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth size="small" sx={fieldStyles}>
                                        <InputLabel id="Compensacion">
                                            Compensación
                                        </InputLabel>

                                        <Select
                                            labelId="Compensacion"
                                            id="compensation"
                                            defaultValue={0}
                                            label="Compensación"
                                            {...register('compensation')}
                                        >
                                            <MenuItem value={0}>Jugadas</MenuItem>
                                            <MenuItem value={1}>COP</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </SectionBox>
                    </Grid>

                    <Grid item xs={12}>
                        <LoadingButton
                            fullWidth
                            loading={submit}
                            loadingPosition="start"
                            startIcon={<i className="fa-solid fa-floppy-disk"></i>}
                            variant="contained"
                            size="large"
                            type="submit"
                            sx={{
                                borderRadius: '14px',
                                py: 1.1,
                                fontWeight: 900,
                                textTransform: 'uppercase',
                                background: 'linear-gradient(90deg, #10285f 0%, #1a2f5c 100%)',
                                boxShadow: '0 6px 14px rgba(15, 34, 77, 0.18)',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #1a2f5c 0%, #10285f 100%)',
                                },
                            }}
                        >
                            <span>Guardar premio</span>
                        </LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </ModalCard>
    );
};

export default AddPrize;

const fieldStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '14px',
        background: '#fff',
        color: '#10285f',
        fontWeight: 700,

        '& fieldset': {
            borderColor: 'rgba(15, 34, 77, 0.16)',
        },

        '&:hover fieldset': {
            borderColor: 'rgba(214, 170, 58, 0.7)',
        },

        '&.Mui-focused fieldset': {
            borderColor: '#d6aa3a',
            borderWidth: '2px',
        },
    },

    '& .MuiInputLabel-root': {
        color: 'rgba(15, 34, 77, 0.65)',
        fontWeight: 700,
    },

    '& .MuiInputLabel-root.Mui-focused': {
        color: '#10285f',
    },
};

const ModalCard = styled.div`
    width: min(92vw, 520px);
    padding: 1.2rem;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f6f8ff 100%);
    border: 1px solid rgba(214, 170, 58, 0.28);
    box-shadow: 0 18px 48px rgba(0, 0, 0, 0.22);

    @media (max-width: 600px) {
        padding: 0.95rem;
        border-radius: 18px;
    }
`;

const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 1rem;

    .left {
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    .icon {
        width: 44px;
        height: 44px;
        border-radius: 15px;
        background: rgba(214, 170, 58, 0.16);
        border: 1px solid rgba(214, 170, 58, 0.3);
        color: #10285f;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        svg {
            font-size: 1.45rem;
        }
    }

    .title {
        color: #10285f;
        font-size: 1.3rem;
        font-weight: 900;
        line-height: 1.1;
    }

    .subtitle {
        margin-top: 0.15rem;
        color: rgba(15, 34, 77, 0.62);
        font-size: 0.84rem;
        font-weight: 600;
    }

    .close-btn {
        color: #10285f;
        background: rgba(16, 40, 95, 0.06);

        &:hover {
            background: rgba(214, 170, 58, 0.16);
        }
    }
`;

const SectionBox = styled.div`
    padding: 1rem;
    border-radius: 18px;
    background: rgba(16, 40, 95, 0.035);
    border: 1px solid rgba(15, 34, 77, 0.08);
`;

const SectionTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 0.65rem;
    margin-bottom: 0.85rem;

    svg {
        color: #d6aa3a;
        font-size: 1.25rem;
        flex-shrink: 0;
    }

    .section-title {
        color: #10285f;
        font-size: 0.95rem;
        font-weight: 900;
        line-height: 1.1;
    }

    .section-subtitle {
        margin-top: 0.1rem;
        color: rgba(15, 34, 77, 0.58);
        font-size: 0.76rem;
        font-weight: 600;
    }
`;